// extracted by mini-css-extract-plugin
module.exports = {"card__container":"styles_card__container__q-ZvT","card__header":"styles_card__header__E7QMB","card__body":"styles_card__body__2oGlg","card__link":"styles_card__link__16RA0"};